import { JSX } from 'preact/jsx-runtime';

import cx from 'clsx';

export type DataColumn<T> = {
	id: string;
	header: string;
	align?: 'left' | 'center' | 'right';
	render: (item: T) => JSX.Element | string | number;
	width?: string;
};

type DataTableProps<T> = {
	id: string;
	data: T[];
	columns: DataColumn<T>[];
	className?: string;
};

export const DataTable = <T extends { cardId: string }>({
	id,
	data,
	columns,
	className,
}: DataTableProps<T>) => (
	<div
		className={cx(
			'border1 border-grey2 border-radius2 width100 height100 overflow-y-auto bg-white',
			className,
		)}
	>
		<table id={id} className="width100">
			<thead className="h5 dark3 sticky top0">
				<tr className="border-bottom1 border-grey2">
					{columns.map((col) => (
						<th
							key={col.id}
							className={cx('p4 medium', col.align ? `${col.align}-align` : '')}
						>
							{col.header}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{data.map((item) => (
					<tr key={item.cardId}>
						{columns.map((col) => (
							<td
								key={col.id}
								className={cx('py2 px4', col.align ? `${col.align}-align` : '')}
							>
								{col.render(item)}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

export default DataTable;
